import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import cartReducer from "./cartReducer";
import documentReducer from "./documentReducer";
import loadingReducer from "./loadingReducer";
import modalReducer from "./modalReducer";
import permitLimitsReducer from "./permitLimitsReducer";
import permitTypeReducer from "./permitTypeDetailsReducer";
import settingsReducer from "./settingsReducer";
import applicationReducer from "./userApplicationReducer";
import userCitationReducer from "./userCitationReducer";
import userPermitReducer from "./userPermitReducer";

export default combineReducers({
	/**
	 * Global cart information
	 */
	cart: cartReducer,
	/**
	 * The global form object for redux-form. Don't change this...
	 */
	form: formReducer,
	/**
	 * Contains user's permit information.
	 * Ex: Manage-permits loads in the user permit to be shared across cards.
	 */
	userPermits: userPermitReducer,
	/**
	 * Users application which are loaded in on the dashboard.
	 */
	userApplications: applicationReducer,
	/**
	 * Users Citations
	 */
	userCitations: userCitationReducer,
	/**
	 * The users documents which are maintained on the 'apply' process
	 */
	documents: documentReducer,
	/**
	 * The permit type details which are selected on the dropdown on dashboard.
	 * This is shared across ALL form pages on 'apply'. This is crucial.
	 */
	activePermitTypeDetails: permitTypeReducer,
	/**
	 * The Operator Settings which determined if it should be address first search.
	 */
	settings: settingsReducer,
	/**
	 * The modal that is toggled when a user rejects a waitlisted permit.
	 */
	modal: modalReducer,
	/**
	 *  The state which determines the text on the buttons for Renew Now and Keep Waitlist Position
	 */
	loading: loadingReducer,
	/**
	 *  The state which determines the text on the buttons for Renew Now and Keep Waitlist Position
	 */
	limits: permitLimitsReducer,
});
